import Typography from '@mui/material/Typography';

import { clicksLine, type LinkView } from './linkState';

/** "12 clicks · last 30 days": taps on the button, never donations (P6). */
export function ClicksLine({ view }: { view: LinkView }) {
  return (
    <Typography color="text.secondary" data-testid={`arc-${view.kind}-clicks-value`}>
      {clicksLine(view.clicks, view.range)}
    </Typography>
  );
}
